import { auth } from '../config/data/firebase';
import { claimChatAccountTransition, prepareChatAccountTransition } from './api/chatClient';

export const CHAT_THREAD_STORAGE_KEY = 'pf-live-chat-thread';

export const preparePendingChatTransition = async (): Promise<string | null> => {
	if (!auth.currentUser?.isAnonymous || !window.localStorage.getItem(CHAT_THREAD_STORAGE_KEY)) return null;
	return prepareChatAccountTransition();
};

export const claimPendingChatTransition = async (token: string | null): Promise<void> => {
	if (token) await claimChatAccountTransition(token);
};
